const DEFAULT_LOCAL = "http://localhost:8000/api/v1";
const DEFAULT_PRODUCTION = "https://optimus.server.sypto.xyz/api/v1";

function normalize(url: string): string {
  return url.trim().replace(/\/$/, "");
}

export function getLocalApiUrl(): string {
  return normalize(import.meta.env.VITE_LOCAL_API_URL || DEFAULT_LOCAL);
}

export function getProductionApiUrl(): string {
  return normalize(
    import.meta.env.VITE_PRODUCTION_API_URL || DEFAULT_PRODUCTION
  );
}

/**
 * VITE_API_TARGET=local|production (default: production unless explicitly set to local).
 */
export function getApiTarget(): "local" | "production" {
  const configured = (import.meta.env.VITE_API_TARGET || "").toLowerCase();
  if (configured === "local") {
    return "local";
  }
  return "production";
}

export function getApiBaseUrl(): string {
  return getApiTarget() === "local" ? getLocalApiUrl() : getProductionApiUrl();
}

/** All backend URL prefixes for JWT fetch patch */
export function getBackendUrlPrefixes(): string[] {
  const bases = [getApiBaseUrl(), getLocalApiUrl(), getProductionApiUrl()];
  return [...new Set(bases.filter(Boolean))];
}
